export const RESTRICTION_TYPE = {
  CASH_ACCESS_RESTRICTION: 'CASH ACCESS RESTRICTION',
  MCC_RESTRICTION: 'MCC RESTRICTION',
  DAILY_SPEND_LIMIT_RESTRICTION: 'DAILY SPEND LIMIT RESTRICTION'
};
